import tw, { styled } from 'twin.macro'
import { maxWidth } from '../styles/width'

const Container = styled.div`
  ${tw`pb-8 md:pb-16 mx-auto px-6`};
  max-width: ${maxWidth};
`

export default Container
